/**
 * Vista RSC Client Entry
 *
 * This file is auto-generated. Do not edit directly.
 * It hydrates using React Flight data from /rsc and enables
 * RSC-aware client-side navigation via RSCRouter.
 */

import * as React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { createFromFetch } from 'react-server-dom-webpack/client';
import { RSCRouter } from 'vista/client/rsc-router';
import { callServer } from 'vista/client/server-actions';

const hydrateDocument = (window as any).__VISTA_HYDRATE_DOCUMENT__ === true;
const rootElement = hydrateDocument ? document : document.getElementById('root');
if (!rootElement) {
  throw new Error('Missing #root element for hydration.');
}




function buildRuntimeMessage(title: string, error: unknown): string {
  var value = error as any;
  var text = '';
  if (value && typeof value === 'object') {
    if (typeof value.message === 'string' && value.message.trim().length > 0) {
      text = value.message;
    }
    if (typeof value.stack === 'string' && value.stack.trim().length > 0) {
      text = text ? text + '\n\n' + value.stack : value.stack;
    }
  }
  if (!text) {
    text = typeof error === 'string' ? error : String(error || 'Unknown runtime error.');
  }
  return title + '\n\n' + text;
}

function reportDevRuntimeError(title: string, error: unknown): void {
  if (typeof window === 'undefined') return;
  var indicator = (window as any).__VISTA_DEVTOOLS_INDICATOR__;
  var overlay = (window as any).__VISTA_DEV_ERROR_OVERLAY__;
  var message = buildRuntimeMessage(title, error);
  var canRestoreFromIndicator = false;
  if (indicator && indicator.hidden !== true && typeof indicator.setError === 'function') {
    canRestoreFromIndicator = true;
    if (typeof indicator.ensureAttached === 'function') {
      try {
        canRestoreFromIndicator = indicator.ensureAttached() !== false;
      } catch {
        canRestoreFromIndicator = false;
      }
    }
  }
  if (indicator && typeof indicator.setError === 'function') {
    indicator.setError(title, 1);
  }
  if (overlay && typeof overlay.capture === 'function') {
    overlay.capture([message]);
    if (!canRestoreFromIndicator && typeof overlay.show === 'function') {
      overlay.show([message]);
    }
    return;
  }
  if (overlay && typeof overlay.show === 'function') {
    overlay.show([message]);
    if (typeof overlay.minimize === 'function') {
      overlay.minimize();
    }
    return;
  }
  console.error('[vista] ' + title + ':', error);
}

if (typeof window !== 'undefined') {
  window.addEventListener('error', function (event) {
    var runtimeError = (event as ErrorEvent).error || (event as ErrorEvent).message;
    reportDevRuntimeError('Runtime Error', runtimeError);
  });
  window.addEventListener('unhandledrejection', function (event) {
    reportDevRuntimeError('Unhandled Promise Rejection', (event as PromiseRejectionEvent).reason);
  });
}

const pathname = window.location.pathname;
const search = window.location.search;
const initialResponse = createFromFetch(
  fetch(`/rsc${pathname}${search}`, { headers: { Accept: 'text/x-component' } }),
  { callServer }
) as Promise<React.ReactNode>;

var appElement = React.createElement(RSCRouter, {
  initialResponse,
  initialPathname: pathname,
});

try {
  hydrateRoot(
    rootElement as Document | Element,
    appElement,
    {
      onRecoverableError(error) {
        var message = String((error as any)?.message || error || '');
        if (/hydration|did not match|server rendered html|text content/i.test(message)) {
          reportDevRuntimeError('Hydration Error', error);
          return;
        }
        reportDevRuntimeError('Recoverable Error', error);
      },
    }
  );
} catch (error) {
  reportDevRuntimeError('Hydration Error', error);
  if (!hydrateDocument && rootElement instanceof Element) {
    try {
      createRoot(rootElement).render(appElement);
    } catch (fallbackError) {
      reportDevRuntimeError('Client Render Fallback Failed', fallbackError);
    }
  }
}

// SSE live-reload disabled in production
